import Globals from './globals';

// Este módulo es un fallback para los pocos lugares que manejan
// errores fuera del flujo normal de api.ts (por ejemplo, llamadas
// directas con fetch o axios sin pasar por createResponse).
// Para el flujo normal, el interceptor en axios.ts ya normaliza
// el error y api.ts lo muestra con err.friendlyMessage.
class Error {
  default = (err: any) => {
    const message = err?.friendlyMessage || 'Por favor, revise su conexión';
    Globals.showError(message);
  };
}

export default new Error();
